import React from 'react';
import Style from './sync-button.module.css';
import UserRightsRender from '../../pages/events/dashboard/components/userRightsRender';
import { Button } from '@weezevent/nacre';
import { Icon as SemIcon } from 'semantic-ui-react';

export function SyncButton({ sync, allow = ['admin'] }) {
    return (
        <UserRightsRender allow={allow}>
            <Button className={Style['sync-button']} primary inverted key="sync" icon={<SemIcon className={Style['sync-button-icon']} name={'sync'} />} onClick={sync} />
        </UserRightsRender>
    );
}
